import React from 'react';
import { Box, Container, Button } from "@mui/material";
import AuthLayout from "./AuthLayout"

let headers = {
  "Content-Type": "application/json",
}
const DisableSignUpHrNotificationScreen = (props) => {
  const requestAccount = (e) => {
    if (!props.hr_detail.request_url) return
    e.preventDefault();
    $.ajax({
      method: 'POST',
      url: props.hr_detail.request_url,
      headers: headers,
      success: (response) => {
        toastr.success(response.message)
      },
      error: (err) => {
        toastr.error(JSON.parse(err.responseText).message)
      }
    })
  }

  return (
    <AuthLayout isConfidentialPlanning={props.is_confidential_planning}>
      <Container maxWidth="sm">
        <div style={styles.registrationDiv}>
          <div style={styles.headings}>
            <span style={styles.heading1}>
              {props.hr_detail.title ? <span className="underline">{props.hr_detail.title}</span> : ''}
            </span>
          </div>
          <Box>
            <div style={styles.headings}>
              <span style={styles.heading1}>
                {props.hr_detail.message}
              </span>
            </div>
            <div style={styles.formGroup}>
              <Button sx={{ fontFamily: "MontserratRegular" }} className="primary-login-button" type="submit" onClick={requestAccount}>
                Request Account
              </Button>
            </div>
          </Box>
        </div>
      </Container>
    </AuthLayout>
  )
}

const styles = {
  headings: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: 70,
    marginBottom: 30,
  },
  formDiv: {
    marginTop: 40,
    display: "flex",
    flexDirection: "column",
  },
  registrationDiv: {
    paddingTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 10px)'
  },
  heading1: {
    fontSize: 32,
    fontFamily: "MontserratExtraBold",
  }
};

export default DisableSignUpHrNotificationScreen;
